import {
  type AssetPosition,
  assetPositionActionTypesEnum,
  periodEnum,
} from "kubb";
import type React from "react";
import DisplayIfUserType from "../../../components/utils/DisplayIfUserType/DisplayIfUserType.tsx";
import CreateActionButton from "../assetActions/CreateActionButton.tsx";
import ReceiverAssignmentTable from "./ReceiverAssignmentTable";
import WirelessRFDataApiWrapper from "./WirelessRFDataApiWrapper";

export default function WirelessClusterReceiverAssignmentTab(props: {
  clusterPosition: AssetPosition;
}): React.ReactElement {
  const { clusterPosition } = props;
  return (
    <>
      <WirelessRFDataApiWrapper
        request={{
          company_id: clusterPosition.company_id,
          scheme_id: clusterPosition.scheme_id,
          period: periodEnum.ALL,
          parent_asset_position_id: clusterPosition.asset_position_id,
        }}
      >
        {(props) => (
          <div className={"min-w-full min-h-80"}>
            <ReceiverAssignmentTable
              {...props}
              wirelessCluster={clusterPosition}
            />
          </div>
        )}
      </WirelessRFDataApiWrapper>
      <DisplayIfUserType userTypes={"admin"}>
        <span className={"px-1"}>
          <CreateActionButton
            assetPosition={clusterPosition}
            action={{
              action_type:
                assetPositionActionTypesEnum.ASSIGN_ALL_ASSETS_TO_ALL_WIRELESS_RECEIVERS,
            }}
            actionName={"Assign All Assets to All Receivers"}
          />
        </span>
        <span className={"px-1"}>
          <CreateActionButton
            assetPosition={clusterPosition}
            action={{
              action_type:
                assetPositionActionTypesEnum.AUTO_ASSIGN_ASSETS_TO_WIRELESS_RECEIVERS,
            }}
            actionName={"Optimise Assets to Receivers"}
          />
        </span>
        <span className={"px-1"}>
          <CreateActionButton
            assetPosition={clusterPosition}
            action={{
              action_type:
                assetPositionActionTypesEnum.AUTO_ASSIGN_ASSETS_TO_WIRELESS_RECEIVERS_AND_SYNC,
            }}
            actionName={"Optimise Assets to Receivers And Sync Device Lists"}
          />
        </span>
      </DisplayIfUserType>
    </>
  );
}
